module.exports = __webpack_public_path__ + "static/media/evening-active.663343e1.png";